<template>
  <v-container>
    <v-layout column>
      <v-flex mt-6>
        <v-img src="../assets/logo.png" height="100" contain></v-img>
      </v-flex>
      <v-flex mt-6>
        <v-card dark class="mx-auto" max-width="600" color="rgb(18,18,18,0.5)">
          <v-toolbar flat color="transparent">
            <v-toolbar-title>User Login</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn to="sign-up" color="secondary darken-2">
              Create Account</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="login"
            >
              <v-text-field
                v-model="emailAddress"
                :rules="emailAddressRules"
                type="email"
                label="Email Address"
                required
                prepend-icon="mdi-account-circle"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                type="password"
                label="Password"
                required
                prepend-icon="mdi-lock"
              ></v-text-field>
              <forgotten-password></forgotten-password>
              <v-btn
                class="d-block mt-4"
                type="submit"
                color="primary darken-2"
                :loading="loading"
                >Login</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="userAccepted" width="100%" persistent>
      <v-card>
        <v-card-title>
          Please review and accept our privacy statement before continuing
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="privacyStatementDialog = true"
            >View</v-btn
          >
          <v-btn color="primary darken-2" @click="userAccepted = false"
            >Accept</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="privacyStatementDialog"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary" fixed>
          <v-btn icon dark @click="privacyStatementDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Privacy Statement</v-toolbar-title></v-toolbar
        >
        <privacy-statement style="overflow:auto"></privacy-statement>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ForgottenPassword from "../components/auth/ForgottenPassword.vue";
import PrivacyStatement from "../components/common/PrivacyStatement.vue";
//import ApiService from '../services/ApiService'

export default {
  name: "Login",
  components: {
    ForgottenPassword,
    PrivacyStatement
  },
  data() {
    return {
      valid: true,
      userAccepted: true,
      privacyStatementDialog: false,
      emailAddress: "",
      emailAddressRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      loading: false
    };
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("login", {
            emailAddress: this.emailAddress,
            password: this.password
          })
          .then(() => {
            this.$router.push({ name: "Home" });
          })
          .catch(() => {
            alert("Username or password was incorrect");
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style>
.bg {
  background-image: url("../assets/LandingPage_01.jpg");
  background-size: cover;
}
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
